<template>
    <div class="loading">
        <div
            v-for="n in 3"
            :class="`bounce${n}`"
            :style="{backgroundColor: color}"
            :key="n"
        />
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',
    props: {
        color: {
            type: String,
            default: '#fff',
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    display: flex;
    justify-content: center;
    align-items: center;
}
.loading > div {
    width: 14px;
    height: 14px;
    margin: 0 3px;
    background-color: #fff;
    border-radius: 100%;
    animation: bouncedelay 1s infinite ease-in-out both;
}
.loading .bounce1 {
    animation-delay: -0.3s;
}
.loading .bounce2 {
    animation-delay: -0.15s;
}
@keyframes bouncedelay {
    0%,
    100% {
        transform: scale(0);
    }
    50% {
        transform: scale(1);
    }
}
</style>
